/**
 * @fileoverview UI slice — mobile menü ve genel UI state.
 */

import { createSlice } from '@reduxjs/toolkit'

/** @type {{ mobileMenuOpen: boolean }} */
const initialState = {
  mobileMenuOpen: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    /** Mobile menü aç/kapat */
    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen
    },
    /** Mobile menüyü zorla kapat (route değişimi vb.) */
    closeMobileMenu: (state) => {
      state.mobileMenuOpen = false
    },
  },
})

export const { toggleMobileMenu, closeMobileMenu } = uiSlice.actions

// Memoized selector
/** @param {{ ui: typeof initialState }} state */
export const selectMobileMenuOpen = (state) => state.ui.mobileMenuOpen

export default uiSlice.reducer
